import React from 'react';

import {WORKSPACE_MEDIA_SETTINGS_DESCRIPTION} from '../constants';
import {MediaSettingsDrawerContent} from './MediaSettingsDrawerContent';
import {
  MediaSettingsDrawerContextProvider,
  useWorkspaceMediaSettingsDrawer,
} from './MediaSettingsDrawerContextProvider';
import {SettingsLevel} from './types';

export const WorkspaceMediaSettingsDrawer = ({
  header,
}: {
  header: React.ReactNode;
}) => {
  const contextValue = useWorkspaceMediaSettingsDrawer();
  return (
    <MediaSettingsDrawerContextProvider contextValue={contextValue}>
      <MediaSettingsDrawerContent
        header={header}
        description={WORKSPACE_MEDIA_SETTINGS_DESCRIPTION}
        settingsLevel={SettingsLevel.WORKSPACE}
      />
    </MediaSettingsDrawerContextProvider>
  );
};
